import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Login from './pages/Login';
import useToastDismiss from './utils/hooks/useToastDismiss';

import OtpVerification from './components/Auth/OTP/OtpVerification';
import { CreatePassword, ForgotPassword } from './pages/Password';
import SignUp from './pages/Signup/SignUp';
// Create a wrapper component to handle location and prop changes
const RouteWrapper = ({ children }) => {
  useToastDismiss();
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <RouteWrapper>
        <Routes>
          {/* Public routes that redirect to onboarding if authenticated */}
          <Route path="/login" element={<LoginRouter />} />
          <Route path="/signup" element={<SignupRouter />} />

          {/* Other routes */}
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/forgot-password" element={<ForgotPasswordRouter />} />
          <Route path="/*" element={<Navigate to="/login" />} />
        </Routes>
        <ToastContainer />
      </RouteWrapper>
    </BrowserRouter>
  );
}

// Router component to handle login screens
function LoginRouter() {
  const location = useLocation();
  const screen = location.state?.screen;

  switch (screen) {
    case 'otp':
      return (
        <OtpVerification isLoginFlow={true} key={location?.state?.otpKey} />
      );
    default:
      return <Login />;
  }
}

// Router component to handle signup screens
function SignupRouter() {
  const location = useLocation();
  const screen = location.state?.screen;

  switch (screen) {
    case 'otp':
      return (
        <OtpVerification isLoginFlow={false} key={location?.state?.otpKey} />
      );
    case 'set-password':
      return <CreatePassword />;
    default:
      return <SignUp />;
  }
}

// Router component to handle forgot password screens
function ForgotPasswordRouter() {
  const location = useLocation();
  const screen = location.state?.screen;

  switch (screen) {
    case 'otp':
      return (
        <OtpVerification isForgotFlow={true} key={location?.state?.otpKey} />
      );
    case 'reset-password':
      return <CreatePassword isForgotFlow={true} />;
    default:
      return <ForgotPassword />;
  }
}

export default App;
